<template>
    <div>
        <div class="banner">
            <span>{{$t("about.banner")}}</span>
        </div>
        <div class="section-wrap ">
            <tabnav :tab="tab"></tabnav>
            <div class="tab-content ">

                <div :class="(tab==2?'':'hide')+' tab2'">
                    <div class="tab-nav2 clearfix">
                        <span :class="tab2==0?'active':''" @click="getNews(0)">{{ $t("news.nav1") }}</span><span :class="tab2==2?'active':''"  @click="getNews(2)">{{ $t("news.nav2") }}</span><span :class="tab2==1?'active':''"  @click="getNews(1)">{{ $t("news.nav3") }}</span>
                    </div>
                    <div v-show="list.length==0" class="tc b-fff">
                        {{$t("common.date_list")}}
                    </div>
                    <ul class="clearfix news-ul b-fff">
                        <li class="news-li" v-for="(item,index) in list" @click="routerSkip('/news/detail/'+(item.id))">
                            <div>
                                <div class="news-li-img" :style="'background:url('+item.frontCover +'?imageView2/2/w/400/interlace/1) no-repeat center/cover'">
                                </div>
                                <div class="news-li-info">
                                    <p class="c-999">{{item.releaseTime}}</p>
                                    <p class="c-333 cbg-textOver2">{{item.title}}</p>
                                    <p class="c-999 cbg-textOver2 pc" ><span v-html="item.article"></span></p>
                                </div>
                            </div>

                        </li>
                    </ul>

                    <div class="pagination clearfix" v-show="list.length>0">
                        <a-pagination :class="$i18n.locale" v-model="listQuery.page" :page-size="listQuery.number" :total="listQuery.total" show-less-items/>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import tabnav from './components/tabnav'
    import { selectJournalism } from '@api/index'
    import { mapMutations,mapActions } from 'vuex'


    export default {
        name: 'news',
        components: {tabnav},
        data () {
            return {
                tab:2,
                tab2:0,
                frontCover:"@/assets/images/tech/img1.png",
                listQuery:{
                    classify:'',
                    number:12,
                    page:1,
                    totalPage:1,
                    total:9
                },
                curImg:'',
                showLayerBig:false,
                list:[],


            }
        },
        created () {

        },
        mounted(){
            this.listQuery.languageType = this.$i18n.locale
            this.getNews(0)
        },
        methods: {
            getList() {
                this.$loading.show()
                selectJournalism(this.listQuery).then(res=>{
                    this.$loading.hide()
                    if(res.code==0){
                        this.listQuery.total=res.data.total
                        this.listQuery.totalPage=res.data.totalPage
                        this.list=res.data.list
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            getNews(type){
                this.tab2=type
                this.listQuery.classify=type==0?'':type
                this.getList()
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import "~@/assets/css/public.styl"

    .realize-more
        user-select none;cursor pointer
    h2,h3,h4,h5,h6,p{
        margin: 0
    }

    .banner{height:280px;background :url("~@/assets/images/about/banner.jpg") no-repeat center/auto 100%;}
    .tab-nav>div{width:25%;}
    .tab-content{margin-bottom: 1.45rem;}
    .text1{font-size:.16rem;color:#666666;width:6.5rem;margin:0 auto;line-height:.32rem;padding:.56rem 0 .63rem;text-align:center;}



    .news-ul{padding:0 0.5rem .5rem;    margin-bottom: .2rem;}
        .news-li{width:32.24%;margin-right:1.64%;margin-bottom:1.64%;fl();cursor :pointer;height:3.4rem;
        &:nth-child(3n){margin-right:0;}
            .news-li-img{height:1.95rem;}
            .news-li-info{width:91%;margin:0 auto;margin-top:-.3rem;background :#f8f8f8;height:1.78rem;padding:.15rem .2rem;font-size:.14rem;line-height:.24rem;transition: transform .2s linear, background .15s linear;;
            .c-333{font-size:.16rem;margin:.08rem 0;}

            }
            &:hover .news-li-info{transform: translate3d(0,-.1rem,0);background: $standardColor;
            p{color:#fff;}
            }
        }

    .tab1{background:#fff;}
    .tab-nav2{color:#333;background :#fff;padding:.3rem .5rem .4rem;
        span{border-radius :.24rem;padding:0 .12rem;font-size:.14rem;line-height .24rem;margin-right:.28rem;cursor :pointer;display :inline-block;
            &.active{color:#fff;background :$standardColor;}
        }

    }

    @media screen and (max-width: 768px){
        .English {
            .tab-nav2 span{margin:0 0.18rem}
        }
        .tab2{background:#fff;padding-bottom:.7rem;}
        .section-wrap{padding:0;}
        .banner{height:3.7rem;background url("~@/assets/images/about/m-banner.jpg") no-repeat center/auto 100%;}
        .tab-content{background:#f8f8f8;margin-bottom: 0;}
        .text1{font-size:.26rem;width:86%;line-height:.56rem;padding:.55rem 0 .3rem;}
        .video{border-radius:0;}

        .tab-nav2{text-align:center;    padding: 0.63rem 0.24rem 0.9rem;
        span{font-size:.24rem;line-height :.48rem;padding:0 .18rem;margin:0 .33rem;}
        }
        .news-ul{padding:0 .24rem;    margin-bottom: .5rem;}
        .news-li{width:48.57%;margin-right :2.86%;margin-bottom:2.86%;height:3.6rem;
            &:nth-child(3n){margin-right:2.86%;}
            &:nth-child(2n){margin-right:0;}
            &:hover .news-li-info{transform: translate(0,0rem);background: #f8f8f8;
                .c-999{color:#999}
                .c-333{color:#333}
            }
            .news-li-img{height:1.9rem;}
            .news-li-info{width:100%;margin :0;height:1.7rem;font-size :.2rem;    padding: 0.25rem 0.2rem;
            .c-333{font-size:.26rem;line-height: 0.4rem;margin: 0.1rem 0;}

        }

        }


    }
</style>
<style >
    body{background :#f8f8f8}
    .news-li-info img{display: none!important;}
</style>
